function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.73534 22.7959L12.7267 19.4614V22.5901L7.55358 24.319C6.75904 24.6373 6.60358 24.8665 6.97879 25.3894C7.43045 25.801 9.03165 25.7187 9.9759 25.3894L12.7267 24.319V27.036C11.7413 27.2666 10.2907 27.3242 9.68851 27.3242C6.67223 27.338 3.27082 26.2432 2.70893 25.7187C1.51832 24.6072 1.80574 23.5369 3.73534 22.7959Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7531 6V28.3945L18.762 30V10.9811C18.8473 10.292 19.0092 10.0148 19.7063 9.91081C20.2014 9.86046 20.8928 10.6067 20.8558 10.9811V19.4614C21.5217 19.8567 21.9748 19.981 22.9086 20.0377C25.318 19.8542 26.3899 19.2371 26.5627 14.9331C26.5799 11.8989 25.8535 10.5069 22.9086 8.71698C19.5229 7.21824 17.496 6.67425 13.7531 6Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7063 24.8542V21.7667C21.2795 21.2885 22.2136 21.0712 24.0993 20.9022C26.3985 20.6963 28.8208 20.7376 32.4748 22.2607C33.5833 22.7228 34.3634 24.4837 31.1199 25.7187L19.7063 29.753V26.7067L27.9996 23.825C28.9916 23.4713 29.0671 23.0017 28.4102 22.7959C27.507 22.4666 26.6038 22.5077 25.7415 22.7959L19.7063 24.8542Z",
  fill: "white"
});

var SvgPlaystation = function SvgPlaystation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaystation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playstation.2142cee7.svg";
export { ForwardRef as ReactComponent };